import { useIsMutating as reactQueryUseIsMutating } from '@tanstack/react-query';

const useIsMutating = params => reactQueryUseIsMutating(params);

export default useIsMutating;
